import { render, staticRenderFns } from "./notificationCenterPopup.vue?vue&type=template&id=6d06693c&scoped=true&"
import script from "./notificationCenterPopup.vue?vue&type=script&lang=js&"
export * from "./notificationCenterPopup.vue?vue&type=script&lang=js&"
import style0 from "./notificationCenterPopup.vue?vue&type=style&index=0&id=6d06693c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06693c",
  null
  
)

export default component.exports